import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
import { mapState } from "vuex";
import FormEditPage from "../../components/FormEditPage";
import CardItem from "@/pages/designCategory/components/CardItem";
import Title from "@/pages/designCategory/components/Title";
import ColorPicker from "@/pages/designCategory/components/ColorPicker";
import FileUpload from "@/pages/designCategory/components/FileUpload";
import InputBar from "@/pages/designCategory/components/InputBar";
import cactegoryJson from '../../tools/categorys.json';
import { initLang } from "@/pages/designCategory/tools/utils";
export default {
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    FormEditPage: FormEditPage,
    CardItem: CardItem,
    Title: Title,
    ColorPicker: ColorPicker,
    FileUpload: FileUpload,
    InputBar: InputBar
  },
  data: function data() {
    return {
      show: false,
      form: this.$form.createForm(this),
      rightIndex: 0,
      // 右侧选择的index,
      categorys: [],
      // 分类列表
      selectedCategoryType: this.value.categoryid
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    imgHost: function imgHost(state) {
      return state.designCategory.imgHost;
    },
    rightCom: function rightCom(state) {
      return state.designCategory.select_simple_com;
    }
  })), {}, {
    list: function list() {
      if (!this.rightCom.image) return [];
      return [this.imgHost + this.rightCom.image];
    }
  }),
  created: function created() {
    this.getData();
  },
  watch: {
    value: function value() {
      this.selectedCategoryType = this.value.categoryid;
    },
    rightCom: function rightCom() {
      if (!this.rightCom) {
        this.show = false;
        return;
      }
      this.show = true;
    }
  },
  methods: {
    handleCategoryChange: function handleCategoryChange(val) {
      var c = this.categorys.filter(function (item) {
        return item.id === val;
      })[0];
      if (c) {
        initLang(this.value.title, c.settingName);
      }
      this.value.categoryid = val;
    },
    getData: function getData() {
      var _this = this;
      Promise.resolve(cactegoryJson).then(function (res) {
        if (res.code === 200) {
          _this.categorys = res.data;
        }
      });
    },
    handleImg: function handleImg() {
      this.rightCom.image = '';
    },
    handleImgSuccess: function handleImgSuccess(val) {
      this.rightCom.image = val;
    }
  }
};